import { axios } from "@/lib/axios";
import { IAPIGetServiceCategories, IAPIGetSubscriptions } from "../../types";

export const getAllSubscriptions = ({
  term,
  limit,
  page,
  searchKey,
  searchWord,
}: {
  term?: string;
  limit?: number;
  page?: number;
  /** Filtre exact cumulable avec `term` (ex: "paymentMean"). */
  searchKey?: string;
  searchWord?: string;
} = {}): Promise<IAPIGetSubscriptions> => {
  return axios.get("/payment-s/api/v1/purchases", {
    params: {
      fields: [
        "email",
        "name",
        "phone",
        "customerId",
        "paymentId",
        "subscriptionId",
      ],
      term,
      limit,
      page,
      searchKey,
      searchWord,
    },
  });
};

export const getServiceCategories = (): Promise<IAPIGetServiceCategories> => {
  return axios.get("/payment-s/bo/api/v1/service-categories");
};
